export const APPOINTMENT_FORM_KIND = {
  FORM: "FORM",
} as const;

// Only patient forms are listed here; assessments live in their own panels.
export const APPOINTMENT_FORM_GROUPS = [
  {
    kind: APPOINTMENT_FORM_KIND.FORM,
    label: "Forms",
    emptyText: "No forms available",
  },
] as const;

export const APPOINTMENT_FORM_SUBMITTED_STATUS = "COMPLETED";

export const APPOINTMENT_FORMS_TEXT = {
  previewForm: "Preview Form",
  placeholder: "-",
  loadError: "Unable to load forms",
} as const;

export const APPOINTMENT_FORM_LABEL_COLOR = "#1A1A1A80";
export const APPOINTMENT_FORM_VALUE_COLOR = "#373D41";
